/**
 * Application version information
 * Auto-generated during build - do not edit manually
 */

interface VersionInfo {
  gitTag: string
}

// This will be populated during build
let versionData: VersionInfo | null = null

// Dynamically import version.json if it exists
try {
  // @ts-ignore - version.json is generated at build time
  versionData = await import('./version.json')
} catch {
  // Fallback for development when version.json doesn't exist
  versionData = {
    gitTag: '',
  }
}

/**
 * Get the git tag (e.g., "20.19.0-2025-12-16")
 * Returns empty string if no tag exists
 */
export function getGitTag(): string {
  return versionData?.gitTag || ''
}
